export const SET_YOUTUBE_PLAYLIST_DATA = '[YOUTUBE] SET_YOUTUBE_PLAYLIST_DATA';

import { fetchYoutubePlaylistsData } from 'js/services/api';

export const fetchYoutubePlaylists = () => {
  return async (dispatch) => {
    const data = await fetchYoutubePlaylistsData();

    dispatch({
      type: SET_YOUTUBE_PLAYLIST_DATA,
      payload: data.payload,
    });
  };
};
